// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/repo_stacks.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { RepoPullRequest } from "./repo_pulls_dashboard_pb";
import { file_pull_requests_v1_repo_pulls_dashboard } from "./repo_pulls_dashboard_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/repo_stacks.proto.
 */
export const file_pull_requests_v1_repo_stacks: GenFile = /*@__PURE__*/
  fileDesc("CiJwdWxsX3JlcXVlc3RzL3YxL3JlcG9fc3RhY2tzLnByb3RvEhdnaXRodWIucHVsbF9yZXF1ZXN0cy52MSKbAgoWUmVwb1N0YWNrc0xpc3RSZXNwb25zZRI5CgZzdGFja3MYASADKAsyKS5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5SZXBvU3RhY2tTdW1tYXJ5EhIKCm9wZW5fY291bnQYAiABKAUSFwoPY29tcGxldGVkX2NvdW50GAMgASgFEhQKDGN1cnJlbnRfcGFnZRgEIAEoBRITCgt0b3RhbF9wYWdlcxgFIAEoBRI3CgVzdGF0ZRgGIAEoDjIoLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLlJlcG9TdGFja3NTdGF0ZRI1CgRzb3J0GAcgASgOMicuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUmVwb1N0YWNrc1NvcnQi0wIKF1JlcG9TdGFja0RldGFpbFJlc3BvbnNlEjgKBXN0YWNrGAEgASgLMikuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUmVwb1N0YWNrU3VtbWFyeRI/Cg1wdWxsX3JlcXVlc3RzGAIgAygLMiguZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUmVwb1B1bGxSZXF1ZXN0EkAKG3Vuc3RhY2tfcHVsbF9yZXF1ZXN0X251bWJlchgDIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEhoKEnZpZXdlcl9jYW5fdW5zdGFjaxgEIAEoCBIgChhhbGxfcHVsbF9yZXF1ZXN0c19sb2NrZWQYBSABKAgSIQoZc29tZV9wdWxsX3JlcXVlc3RzX2xvY2tlZBgGIAEoCBIaChJhdXRvX21lcmdlX2VuYWJsZWQYByABKAgilgIKEFJlcG9TdGFja1N1bW1hcnkSCgoCaWQYASABKAMSDgoGbnVtYmVyGAIgASgDEhUKDWJhc2VfcmVmX25hbWUYAyABKAkSDAoEc2l6ZRgEIAEoBRIUCgxtZXJnZWRfY291bnQYBSABKAUSFgoOdW5tZXJnZWRfY291bnQYBiABKAUSDAoEb3BlbhgHIAEoCBILCgN1cmwYCCABKAkSEgoKY3JlYXRlZF9hdBgJIAEoCRISCgp1cGRhdGVkX2F0GAogASgJElAKE2Nsb3NlZF9wdWxsX3JlcXVlc3QYCyABKAsyMy5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5SZXBvU3RhY2tDbG9zZWRQdWxsUmVxdWVzdCI5ChpSZXBvU3RhY2tDbG9zZWRQdWxsUmVxdWVzdBIOCgZudW1iZXIYASABKAUSCwoDdXJsGAIgASgJKnEKD1JlcG9TdGFja3NTdGF0ZRIhCh1SRVBPX1NUQUNLU19TVEFURV9VTlNQRUNJRklFRBAAEhoKFlJFUE9fU1RBQ0tTX1NUQVRFX09QRU4QARIfChtSRVBPX1NUQUNLU19TVEFURV9DT01QTEVURUQQAipsCg5SZXBvU3RhY2tzU29ydBIgChxSRVBPX1NUQUNLU19TT1JUX1VOU1BFQ0lGSUVEEAASGwoXUkVQT19TVEFDS1NfU09SVF9ORVdFU1QQARIbChdSRVBPX1NUQUNLU19TT1JUX09MREVTVBACYgZwcm90bzM", [file_google_protobuf_wrappers, file_pull_requests_v1_repo_pulls_dashboard]);

/**
 * Blocking payload for GET /:owner/:repo/stacks.
 *
 * @generated from message github.pull_requests.v1.RepoStacksListResponse
 */
export type RepoStacksListResponse = Message<"github.pull_requests.v1.RepoStacksListResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.RepoStackSummary stacks = 1;
   */
  stacks: RepoStackSummary[];

  /**
   * @generated from field: int32 open_count = 2;
   */
  openCount: number;

  /**
   * @generated from field: int32 completed_count = 3;
   */
  completedCount: number;

  /**
   * @generated from field: int32 current_page = 4;
   */
  currentPage: number;

  /**
   * @generated from field: int32 total_pages = 5;
   */
  totalPages: number;

  /**
   * @generated from field: github.pull_requests.v1.RepoStacksState state = 6;
   */
  state: RepoStacksState;

  /**
   * @generated from field: github.pull_requests.v1.RepoStacksSort sort = 7;
   */
  sort: RepoStacksSort;
};

/**
 * Describes the message github.pull_requests.v1.RepoStacksListResponse.
 * Use `create(RepoStacksListResponseSchema)` to create a new message.
 */
export const RepoStacksListResponseSchema: GenMessage<RepoStacksListResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_stacks, 0);

/**
 * Blocking payload for GET /:owner/:repo/stack/:number.
 *
 * @generated from message github.pull_requests.v1.RepoStackDetailResponse
 */
export type RepoStackDetailResponse = Message<"github.pull_requests.v1.RepoStackDetailResponse"> & {
  /**
   * @generated from field: github.pull_requests.v1.RepoStackSummary stack = 1;
   */
  stack?: RepoStackSummary;

  /**
   * Ordered from the highest stack position to the lowest.
   *
   * @generated from field: repeated github.pull_requests.v1.RepoPullRequest pull_requests = 2;
   */
  pullRequests: RepoPullRequest[];

  /**
   * A pull request in the stack. The unstack endpoint is addressed through one of the stack's pull requests.
   *
   * @generated from field: google.protobuf.Int32Value unstack_pull_request_number = 3;
   */
  unstackPullRequestNumber?: number;

  /**
   * The viewer can modify the stack's pull requests (author or push access).
   *
   * @generated from field: bool viewer_can_unstack = 4;
   */
  viewerCanUnstack: boolean;

  /**
   * Every pull request is merged or queued, so unstacking would change nothing.
   *
   * @generated from field: bool all_pull_requests_locked = 5;
   */
  allPullRequestsLocked: boolean;

  /**
   * Some pull requests are merged or queued and would stay in the stack.
   *
   * @generated from field: bool some_pull_requests_locked = 6;
   */
  somePullRequestsLocked: boolean;

  /**
   * The stack's auto-merge request covers at least one pull request, and unstacking disables it.
   *
   * @generated from field: bool auto_merge_enabled = 7;
   */
  autoMergeEnabled: boolean;
};

/**
 * Describes the message github.pull_requests.v1.RepoStackDetailResponse.
 * Use `create(RepoStackDetailResponseSchema)` to create a new message.
 */
export const RepoStackDetailResponseSchema: GenMessage<RepoStackDetailResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_stacks, 1);

/**
 * @generated from message github.pull_requests.v1.RepoStackSummary
 */
export type RepoStackSummary = Message<"github.pull_requests.v1.RepoStackSummary"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 number = 2;
   */
  number: bigint;

  /**
   * @generated from field: string base_ref_name = 3;
   */
  baseRefName: string;

  /**
   * @generated from field: int32 size = 4;
   */
  size: number;

  /**
   * @generated from field: int32 merged_count = 5;
   */
  mergedCount: number;

  /**
   * @generated from field: int32 unmerged_count = 6;
   */
  unmergedCount: number;

  /**
   * A stack is open while any of its pull requests is open.
   *
   * @generated from field: bool open = 7;
   */
  open: boolean;

  /**
   * @generated from field: string url = 8;
   */
  url: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;

  /**
   * The lowest closed, unmerged pull request in an open stack. It blocks merging the stack.
   *
   * @generated from field: github.pull_requests.v1.RepoStackClosedPullRequest closed_pull_request = 11;
   */
  closedPullRequest?: RepoStackClosedPullRequest;
};

/**
 * Describes the message github.pull_requests.v1.RepoStackSummary.
 * Use `create(RepoStackSummarySchema)` to create a new message.
 */
export const RepoStackSummarySchema: GenMessage<RepoStackSummary> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_stacks, 2);

/**
 * @generated from message github.pull_requests.v1.RepoStackClosedPullRequest
 */
export type RepoStackClosedPullRequest = Message<"github.pull_requests.v1.RepoStackClosedPullRequest"> & {
  /**
   * @generated from field: int32 number = 1;
   */
  number: number;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message github.pull_requests.v1.RepoStackClosedPullRequest.
 * Use `create(RepoStackClosedPullRequestSchema)` to create a new message.
 */
export const RepoStackClosedPullRequestSchema: GenMessage<RepoStackClosedPullRequest> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_stacks, 3);

/**
 * @generated from enum github.pull_requests.v1.RepoStacksState
 */
export enum RepoStacksState {
  /**
   * @generated from enum value: REPO_STACKS_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_STACKS_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: REPO_STACKS_STATE_COMPLETED = 2;
   */
  COMPLETED = 2,
}

/**
 * Describes the enum github.pull_requests.v1.RepoStacksState.
 */
export const RepoStacksStateSchema: GenEnum<RepoStacksState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_repo_stacks, 0);

/**
 * @generated from enum github.pull_requests.v1.RepoStacksSort
 */
export enum RepoStacksSort {
  /**
   * @generated from enum value: REPO_STACKS_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_STACKS_SORT_NEWEST = 1;
   */
  NEWEST = 1,

  /**
   * @generated from enum value: REPO_STACKS_SORT_OLDEST = 2;
   */
  OLDEST = 2,
}

/**
 * Describes the enum github.pull_requests.v1.RepoStacksSort.
 */
export const RepoStacksSortSchema: GenEnum<RepoStacksSort> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_repo_stacks, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(RepoStacksListResponseSchema, "21bb90e7db6f")
registerSchemaHash(RepoStackDetailResponseSchema, "1ea9bab76fe6")
registerSchemaHash(RepoStackSummarySchema, "978a0f5089b1")
registerSchemaHash(RepoStackClosedPullRequestSchema, "893ba78d03d0")
